export const updateSortedDiscussionTopicsUuids = uuids => dispatch =>
  dispatch({
    type: 'WORKSPACE_UPDATE_SORTED_DISCUSSION_TOPIC_UUIDS',
    payload: {
      uuids,
    },
  });
